import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useSelector } from "@tanstack/react-store";
import { Stack } from "@bookingcom/bui-react";
import { chartDateRangeStore } from "../../stores/chartDateRangeStore";
import { DiscountedBookingsChartCard } from "../Charts/DiscountedBookingsChart";
import { AverageDiscountChartCard } from "../Charts/AverageDiscountChart";
import { ChartsDataGuard } from "../Charts/ChartsDataGuard";
import { PageErrorState } from "../Charts/PageErrorState";
import { LoadingSpinner } from "../LoadingSpinner";

export const OverviewCharts = () => {
  const { startDate, endDate } = useSelector(chartDateRangeStore, ({ startDate, endDate }) => ({
    startDate,
    endDate,
  }));

  return (
    <ErrorBoundary fallbackRender={() => <PageErrorState />}>
      <Suspense fallback={<LoadingSpinner />}>
        <ChartsDataGuard from={startDate} to={endDate}>
          <Stack gap={6}>
            <DiscountedBookingsChartCard from={startDate} to={endDate} />
            <AverageDiscountChartCard from={startDate} to={endDate} />
          </Stack>
        </ChartsDataGuard>
      </Suspense>
    </ErrorBoundary>
  );
};
